// jQuery('[data-fancybox^="images_"]').fancybox({
//     thumbs : {
//         autoStart : true
//     },
//     mobile : {
//         clickContent : "close",
//         clickSlide : "close"
//     }
// });

jQuery('.link-image').on('click', function(e) {
    e.preventDefault();

    jQuery(this).parent().find("a").first().trigger("click");
});
